// extracted by mini-css-extract-plugin
export default {"footer-column":"Footer_footer-column__i-ywI","new-version-alert":"Footer_new-version-alert__1yQdM","footer-container":"Footer_footer-container__GkqY8"};